
import { useEffect } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { useChat } from '@/contexts/ChatContext';

export function useNotifications() {
  const { user } = useAuth();
  const { totalUnreadCount, loadingMessages } = useChat();
  
  return { unreadCount: totalUnreadCount || 0, isLoading: loadingMessages };
}
